import { h, render, Component } from 'preact';
import { IntlProvider } from 'preact-i18n';
import { Text, MarkupText } from 'preact-i18n';
import axios from 'axios';
import Markup from 'preact-markup';
import SearchInput from './SearchInput';
import HtmlToText from 'html-to-text';

import { Toppers } from './results/Topper';
import { WebResult } from './results/WebResult';
import { OneNewsSnippets, NewsCarousel } from './results/News';
import { OneVideoSnippets, VideoCarousel } from './results/Video';
import { ImageResults, ImageCarousel } from './results/Images';
import { Entity } from './results/Entity';
import { EventsCarousel } from './results/EventsEntity';
import { PlacesCarousel, Place } from './results/Places';
import { Computation, Translation } from './results/Widgets';

import {WidgetHelper} from '../widgets/utils/widgetHelper'
import { OneProduct, ThinkSuggestShoppingResult } from './results/Shopping';

import AePolicy from './AePolicy';
import { GetSearchEndPoint, SetBaseUrl, EscapeQuery, UnescapeQuery, UnEscapeHtml, GetSaferShoppingUrl, GetSetAffiliateId } from '../utils/ApiUtil';
import TopWidget from './TopWidget';
import BottomWidget from './BottomWidget';
import WidgetLoader from "./WidgetLoader";
import AeScrollTop from './AeScrollTop';

import './newSearch.scss';
import RelatedVideoImages from './RelatedVideoImages';
import { TranslationUtil } from '../utils/TranslationUtil';
import { DarkThemeUtil } from '../utils/DarkThemeUtil';
import { SafeSearchUtil } from '../utils/SafeSearchUtil';
import { RtlUtil } from '../utils/RtlUtil';
import { BrowseContextProvider } from '../store/BrowseContextProvider';
import { Footer } from '../common/Footer';

class NewSearch extends Component {

  constructor(props) {
    super(props);
    let lang = TranslationUtil.GetSupportedLanguage();
    this.state = {
      searchResp: {},
      query: "",
      service: "web",
      page: 1,
      loadingSearch: false,
      webSuggestions: [],
      suggestOn: true,
      isSafeSearchOn: false,
      safeSearchLevel: SafeSearchUtil.GetSetSafeSearchLevel(),
      lang: lang,
      activeSelection: -1,
      showLocationWidget: false,
      currentLocation: "",
      affid: props.affid,
      adSafeSearch: "",
      widgetinfo: null,
      definition: {}, 
      isDarkTheme:  DarkThemeUtil.GetSetDarkTheme(), // read dark theme value
      themeMode: DarkThemeUtil.GetThemeMode(),
      isRightToLeft: RtlUtil.GetSetRtl(lang),
      isShowUpperLogo: false,
      currentLocation: window.localStorage.getItem('mycurrentlocation'),
      currentLocationName: window.localStorage.getItem('mycurrentlocationname'),
      currentCountryCode: window.localStorage.getItem('mycurrentcountrycode'),
      showAffiliateLogo: false
    }
    this.resCount = 10;
    this.imgCount = 50;
    this.newsCount = 50;
    this.videosCount = 50;
    this.shopCount = 50;
    this.loadedWidgets = {};
    this.isBrowseLive = false;
    TranslationUtil.GetDefinition(this.state.lang, "search").then(resp => {
      this.setState(c => {
        c.definition = resp;
        return c;
      })
    })
    WidgetHelper.SetParam("translang", this.state.lang, false);
    WidgetHelper.SetParam("affid", this.state.affid, false);
    WidgetHelper.SetParam("currentLocation", this.state.currentLocation, false);
    WidgetHelper.SetParam("currentLocationName", this.state.currentLocationName, false);
    WidgetHelper.SetParam("currentCountryCode", this.state.currentCountryCode, false);
    WidgetHelper.SetParam("safeSearchLevel", this.state.safeSearchLevel, false);
  }
  componentWillMount() {
    if(window.location && window.location.href) {
      if(window.location.href.indexOf("browse.live") > -1 || window.location.href.indexOf("localhost:4000") > -1) {
        this.isBrowseLive = true;
      }
    }
    SetBaseUrl(this.isBrowseLive);
  }
  componentDidMount() {
    /* to communicate with extension
    //chrome.runtime.sendMessage
    let editorExtensionId = "ipnicelldmjgfjggjdohkdjlgclpgkjo";
    if(chrome && chrome.runtime && chrome.runtime.sendMessage) {
      chrome.runtime.sendMessage(editorExtensionId, {type: "GetExtInfo"},
      function(response) {
        //console.log("got the response", response);
      });    
    }
    */
    //latlong, country, lang
    //register for events
    WidgetHelper.RegisterForParamUpdate(() => {
      let currentLocation = WidgetHelper.GetParam("currentLocation");
      let currentLocationName = WidgetHelper.GetParam("currentLocationName");
      let currentCountryCode = WidgetHelper.GetParam("currentCountryCode");
      let isGeoLocation = WidgetHelper.GetParam("isGeoLocation");
      let isDarkTheme = WidgetHelper.GetParam("isDarkTheme");
      if(this.state.currentCountryCode !== currentCountryCode) {
        this.setState(c => {
          c.currentCountryCode = currentCountryCode;
          return c;
        }, this.getSearchResult.bind(this));
        window.localStorage.setItem('mycurrentcountrycode', currentCountryCode);
      } 
      if(this.state.currentLocationName !== currentLocationName) {
        this.setState(c => {
          c.currentLocationName = currentLocationName;
          return c;
        });
        window.localStorage.setItem('mycurrentlocationname', currentLocationName);
      }
      if(this.state.currentLocation !== currentLocation) {
        this.setState(c => {
          c.currentLocation = currentLocation;
          return c;
        });
        window.localStorage.setItem('mycurrentlocation', currentLocation);
      }
      if(this.state.isGeoLocation !== isGeoLocation) {
        this.setState(c => {
          c.isGeoLocation = isGeoLocation;
          return c;
        });
        window.localStorage.setItem('isGeoLocation', isGeoLocation);
      }
      if(this.state.isDarkTheme !== isDarkTheme) {
        this.setState(c => {
          c.isDarkTheme = isDarkTheme;
          return c;
        });
        window.localStorage.setItem('isDarkTheme', isDarkTheme);
      }
    });

    const parameters = new URLSearchParams(window.location.search);
    let query = parameters.get('q');
    if(query) {
      query = UnescapeQuery(query);
      //query = query.replaceAll('%2B', '+');
    }
    const service = parameters.has('service') ? parameters.get('service') : "web";    
    const page = parameters.has('page') ? parameters.get('page') : "1";  
    const adSafeSearch = parameters.has('ss') ? parameters.get('ss') : "";
    if(query) {
      this.setState(c => {
        c.query = query;
        c.service = service;
        c.page = parseInt(page);
        c.adSafeSearch = adSafeSearch;
        return c;
      }, () => {
        // WidgetHelper.SetParam("query", query);
        this.setFromLocalStorage();
        this.handleBackButton();
      })
    } else {
      this.setBackgroundImage();          
      this.setFromLocalStorage();
      this.handleBackButton();  
    }
    this.handleResize();
    window.addEventListener('resize', this.handleResize.bind(this));
  }
  handleResize() {
    let snippetType = "normal";
    let showUpperLogo = false;
    if(document.body.offsetWidth < 550 || (document.body.offsetWidth > 768 && document.body.offsetWidth < 1024)) {
      snippetType = "small";
    }
    if (document.body.offsetWidth < 768) {
      showUpperLogo = true;
    }
    this.setState(c => {
      c.snippetType = snippetType;
      c.isShowUpperLogo = showUpperLogo;
      return c;
    })
  }
  handleBackButton() {
    window.addEventListener('popstate', () => {
      const parameters = new URLSearchParams(window.location.search);
      let query = parameters.get('q');  
      if(query) { 
        //query = query.replaceAll('%2B', '+');
        query = UnescapeQuery(query);
      }
      const service = parameters.has('service') ? parameters.get('service') : "web";    
      const page = parameters.has('page') ? parameters.get('page') : "1";    
      if(this.state.query != query ||
        this.state.service != service ||
        this.state.page != page) {
          this.setState(c => {
            c.query = query;
            c.service = service;
            c.page = parseInt(page);
            c.searchResp = {};
            return c;
          }, () => {
            if(query) {
              this.getSearchResult();
            } else {
              this.setState(c => {
                c.webSuggestions = [];
                c.searchResp = {};
                return c;
              })
            }
          })    
      }
      if(query) {
        this.removeBackgroundImage();
      } else {
        this.setBackgroundImage();
      }
    })
  }
  setAddressAndSearch() {
    this.setAddress();
    this.getSearchResult();
  }
  setAddress() {
    if(this.state.query) {
      let addressUrl = "/search";
      let replaced = '';
      if(this.state.query) {
        //replaced = this.state.query.replaceAll('+', '%2B');
        replaced = EscapeQuery(this.state.query);
        replaced = replaced.replaceAll(/\s+/g, '+');
      }
      addressUrl = `/search?q=${replaced}`;
      if(this.state.service !== "web") {
        addressUrl += `&service=${this.state.service}`;
      }
      if(this.state.page > 1) {
        addressUrl += "&page=" + this.state.page; //TODO 10 should be dynamic;
      }
      //other parameters
      const parameters = new URLSearchParams(window.location.search);
      if(parameters.has("ss")) {
        addressUrl += "&ss=" + (this.state.safeSearchLevel === "none" ? "0" : "1");
      }
      for(var key of parameters.keys()) {
        if(key === "q" || key === "service" || key === "page" || key === "ss" || key === "sslevel" || key === "sl" || !WidgetHelper.IsKnownParam(key)) {
          continue;
        }
        addressUrl += `&${key}=${parameters.get(key)}`;
      }
      window.history.pushState({query: this.state.query}, '', addressUrl);
    }
  }
  setParams() {
    WidgetHelper.SetParam("translang", this.state.lang, false);
    // WidgetHelper.SetParam("query", this.state.query);
    WidgetHelper.SetParam("isSafeSearchOn", this.state.isSafeSearchOn, false);
    WidgetHelper.SetParam("service", this.state.service, false);
    WidgetHelper.SetParam("page", this.state.page, false);
    WidgetHelper.SetParam("affid", this.state.affid, false);
    WidgetHelper.SetParam("isDarkTheme", this.state.isDarkTheme, false);
    WidgetHelper.SetParam("isRightToLeft", this.state.isRightToLeft, false);
    WidgetHelper.SetParam("currentLocation", this.state.currentLocation, false);
    WidgetHelper.SetParam("currentLocationName", this.state.currentLocationName, false);
    WidgetHelper.SetParam("currentCountryCode", this.state.currentCountryCode, false);
    WidgetHelper.SetParam("safeSearchLevel", this.state.safeSearchLevel, true);
  }
  setBackgroundImage() {
    let date = new Date(Date.now());
    let day = date.getDay();
    var imgurl = "/images/safety/bg-" + (day + 1) + "-" + 1 + ".jpg";
    var img = new Image();
    img.onload = function () {
      //set the transition
      document.body.style.background = `url(${imgurl}) no-repeat bottom center fixed`;
      document.body.style.backgroundSize = "cover";
    }
    img.src = imgurl;
  }
  removeBackgroundImage() {
    document.body.style.background = "none";
    document.body.style.backgroundSize = "cover";
  }
  getSearchResult() {
    if(!this.state.query) {
      this.setState(c => {
        c.searchResp = {};
        return c;
      })
      return; //no query
    }
    this.setState(c => {
      c.loadingSearch = true;
      c.loadedWidgets = {};
      return c;
    })
    this.setParams();
    let searchUrl = `${GetSearchEndPoint()}?q=${encodeURIComponent(this.state.query)}&service=${this.state.service}&safesearch=${this.state.safeSearchLevel === "none" ? false: true}&sslevel=${this.state.safeSearchLevel === "none" ? "" : this.state.safeSearchLevel}`;
    let resCount = this.resCount
    if(this.state.service === "images") {
      searchUrl += `&count=${this.imgCount}`;
      resCount = this.imgCount;
    } else if(this.state.service === "videos") {
      searchUrl += `&count=${this.videosCount}`;
      resCount = this.videosCount;
    } else if(this.state.service === "news") {
      searchUrl += `&count=${this.newsCount}`;
      resCount = this.newsCount;
    }
    if(!isNaN(this.state.page) && this.state.page > 1) {
      searchUrl += "&offset=" + (this.state.page-1)*resCount;
    }
    if(this.state.currentCountryCode) {
      searchUrl += "&country=" + this.state.currentCountryCode;
    }
    if(this.state.lang) {
      searchUrl += "&lang=" + this.state.lang;
    }
    if(this.state.currentLocation) {
      searchUrl += "&latlon=" + this.state.currentLocation;
    }
    if(this.state.affid) {
      searchUrl += "&affid=" + encodeURIComponent(this.state.affid); // pass saved affid
    }
    if(this.state.service != "suggestions" && this.state.service != "shopping") {
      searchUrl += "&affsearch=true";
    }
    searchUrl += "&pos=serp";
    
    axios.get(searchUrl) // check if we need to send text over
    .then((response) => {
      document.title = `${UnEscapeHtml(this.state.query)} - Browse.live`;
      this.setState(c => {
        c.loadingSearch = false;
        let searchResp = response.data;
        c.searchResp = searchResp;
        if(response.data.Anchor && response.data.Anchor.affid) {
          c.affid = response.data.Anchor.affid; // save affid so we can pass it again
        }
        // send altered query to widgets if available
        let alteredQuery = this.getAlterationQuery(searchResp);
        let query = alteredQuery ? alteredQuery : this.state.query;
        WidgetHelper.SetParam("query", query, true);
        return c;
      })
    }, (error) => {
      this.setState(c => {
        c.loadingSearch = false;
        return c;
      })
    });
  }
  setService(service) {
    if(service !== this.state.service) {
      this.setState(c => {
        c.loadingSearch = true;
        c.service = service;
        c.page = 1;
        return c;
      },this.setAddressAndSearch.bind(this));
    }
  }

  setFromLocalStorage() {
    let isSafeOn = false;
    if(window.localStorage && window.localStorage.getItem('safeSearchToggled')) {
      isSafeOn = window.localStorage.getItem('safeSearchToggled') === 'true' ? true : false;
    }
    if(this.state.adSafeSearch) {
      isSafeOn = (this.state.adSafeSearch == "1") ? true : false;
    }
    var currentLocation = window.localStorage.getItem('mycurrentlocation');
    var currentLocationName = window.localStorage.getItem('mycurrentlocationname');
    var currentCountryCode = window.localStorage.getItem('mycurrentcountrycode');
    var isGeoLocation = window.localStorage.getItem('isGeoLocation');
    var isDarkTheme = window.localStorage.getItem('isDarkTheme');
    if(!currentLocation) {
      let geoLocObj = (navigator && navigator.permissions) ? navigator.permissions : null;
      if(!geoLocObj || !geoLocObj.query) {
        geoLocObj = (navigator && navigator.geolocation) ? navigator.geolocation : null;
      }
      if(geoLocObj && geoLocObj.query) {
        navigator.permissions.query({
          name: 'geolocation'
        }).then((result) => {
          if(result.state === "granted") {
            navigator.geolocation.getCurrentPosition(pos => {
              let crd = pos.coords;
              currentLocation = `${crd.latitude},${crd.longitude}`;
              window.localStorage.setItem('mycurrentlocation', currentLocation);
              this.setState(c => {
                c.isSafeSearchOn = isSafeOn;
                c.currentLocationName = currentLocationName;
                c.currentCountryCode = currentCountryCode;
                c.currentLocation = currentLocation;
                return c;
              }, this.loadAndSearch.bind(this));
            }, err => {
              this.setState(c => {
                c.isSafeSearchOn = isSafeOn;
                return c;
              }, this.loadAndSearch.bind(this));
            });            
          } else {
            this.setState(c => {
              c.isSafeSearchOn = isSafeOn;
              return c;
            }, this.loadAndSearch.bind(this));
          }
        });    
      } else {
        this.setState(c => {
          c.isSafeSearchOn = isSafeOn;
          return c;
        }, this.loadAndSearch.bind(this));
      }
    } else {
      this.setState(c => {
        c.isSafeSearchOn = isSafeOn;
        c.currentLocation = currentLocation;
        c.currentCountryCode = currentCountryCode;
        c.currentLocationName = currentLocationName;
        return c;
      }, this.loadAndSearch.bind(this));
    }
  }
  loadAndSearch() {
    this.setParams();
    WidgetHelper.DispatchLocationEvent();
    this.getSearchResult();
  }
  onSubmit(query) {
    this.setState(c => {
      c.query = query;
      c.loadingSearch = true;
      c.page = 1;
      return c;
    },this.setAddressAndSearch.bind(this));
  }
  setSafeSearch(safeSearch) {
    let isSafeSearchOn = (safeSearch === "moderate" || safeSearch === "strict") ? true : false;
    let adSafeSearch = (safeSearch === "moderate" || safeSearch === "strict") ? "1" : "0";
    this.setState(c => {
      c.isSafeSearchOn = isSafeSearchOn;
      c.adSafeSearch = adSafeSearch;
      c.safeSearchLevel = safeSearch;
      return c;
    }, () => {
      this.setParams();
      if (isSafeSearchOn) {
        window.localStorage.setItem('safeSearchLevel', safeSearch);
      } else {
        window.localStorage.removeItem('safeSearchLevel');
      }
      window.localStorage.setItem('safeSearchToggled', isSafeSearchOn);
      this.setAddressAndSearch();
    })
  }
  toggleDarkTheme() {
    this.setState(c => {
      c.isDarkTheme = !c.isDarkTheme;
      return c;
    }, () => {
      document.documentElement.setAttribute('data-theme', this.state.isDarkTheme ? 'dark' : 'light');
      WidgetHelper.SetParam("isDarkTheme", this.state.isDarkTheme, true);
      window.localStorage.setItem('isDarkTheme', this.state.isDarkTheme ? 'true': 'false');
    })
  }
  setTheme(theme) {
    let isDarkTheme = false;
    if (theme === "light") {
      isDarkTheme = false;
    }
    if (theme === "dark") {
      isDarkTheme = true;
    }
    if (theme === "system") {
      isDarkTheme = window.matchMedia('(prefers-color-scheme: dark)').matches;
    }
    this.setState(c => {
      c.isDarkTheme = isDarkTheme;
      c.themeMode = theme;
      return c;
    }, () => {
      document.documentElement.setAttribute('data-theme', this.state.isDarkTheme ? 'dark' : 'light');
      WidgetHelper.SetParam("isDarkTheme", this.state.isDarkTheme, true);
      if (theme === "dark" || theme ==='light') {
        window.localStorage.setItem('isDarkTheme', this.state.isDarkTheme ? 'true': 'false');
      } else {
        window.localStorage.removeItem('isDarkTheme');
      }
      
    })
  }
  toggleRightToLeft() {
    this.setState(c => {
      c.isRightToLeft = !c.isRightToLeft;
      return c;
    }, () => {
      document.documentElement.setAttribute('dir', this.state.isRightToLeft ? 'rtl' : 'ltr');
    })
  }
  goToPage(p) {
    if(isNaN(p)) {
      return;
    }
    this.setState(c => {
      c.page = parseInt(p);
      return c;
    }, this.setAddressAndSearch.bind(this))
  }
  handleAffiliateLogoErr(err) {
    //console.log("Error loading affiliate logo", err);
    this.setState(c => {
      c.showAffiliateLogo = false;
      return c;
    })
  }
  handleAffiliateLogoSuccess() {
    this.setState(c => {
      c.showAffiliateLogo = true;
      return c;
    })
  }
  isPoleEntityEvent(section, items, searchResp) {
    try {
      if (section === "pole" && items && items.length > 0 && items[0].answerType === "Entities") {
        let fistValue = (searchResp && searchResp.entities && searchResp.entities.value && searchResp.entities.value.length > 0) ? searchResp.entities.value[0] : "";
        if (fistValue && fistValue._type && fistValue._type === "Event" &&
            fistValue.entityPresentationInfo && fistValue.entityPresentationInfo.entityScenario && fistValue.entityPresentationInfo.entityScenario === "ListItem") {
              return true;
        }
      }
      return false;
    } catch(ex) {
      // do nothing for now
    }
    return false;
  }

  // used for a new visual search topper in the web
  renderTopper() {
    //return ("");
    var searchResp = this.state.searchResp;

    if(this.state.service !== "web" || this.state.loadingSearch || !searchResp || !searchResp.webPages || !searchResp.webPages.value) {
      return "";
    }

    return (<Toppers searchResp={searchResp} isRightToLeft={this.state.isRightToLeft}/>);
  }

  renderSearchResult(section) {
    var searchResp = this.state.searchResp;

    if(this.state.loadingSearch || !searchResp || !searchResp.rankingResponse || !searchResp.rankingResponse[section] || !searchResp.rankingResponse[section].items) {
      return "";
    }

    var items = searchResp.rankingResponse[section].items;

    // special handling for places in the pole position places (they're separate, but need to be put in a shared frame)
    if(section == "pole" && items.length > 0 && items[0].answerType == "Places") {
      return <PlacesCarousel items={items} searchResp={this.state.searchResp} query={this.state.query} section={section} isRightToLeft={this.state.isRightToLeft}/>
    }
    // handling for events in pole position (they're separate, but need to be put in a shared frame)
    if (this.isPoleEntityEvent(section, items, searchResp)) {
      return <EventsCarousel items={items} searchResp={this.state.searchResp} query={this.state.query} section={section} affid={this.state.affid}/>
    }

    let url = window.location.href;
    return (
      <div>
        {items.map(item => {
          if(item.answerType === "WebPages") {
            return <WebResult item={item} searchResp={this.state.searchResp}  query={this.state.query} section={section} affid={this.state.affid}/>;
          } else if(item.answerType === "Videos") {
            return <VideoCarousel item={item} searchResp={this.state.searchResp} query={this.state.query} section={section} affid={this.state.affid} isRightToLeft={this.state.isRightToLeft}/>
          } else if(item.answerType === "News") {
            return <NewsCarousel item={item} searchResp={this.state.searchResp}  query={this.state.query} section={section} affid={this.state.affid} isRightToLeft={this.state.isRightToLeft}/>
          } else if(item.answerType === "Entities") {
            return <Entity item={item} searchResp={this.state.searchResp}  query={this.state.query} section={section} affid={this.state.affid} isRightToLeft={this.state.isRightToLeft}/>
          } else if(item.answerType === "Images") {
            // pass RTL state?
            return <ImageCarousel item={item} searchResp={this.state.searchResp}  query={this.state.query} section={section} affid={this.state.affid} isRightToLeft={this.state.isRightToLeft}/>
          } else if(item.answerType === "Places") {
            if(section == "mainline") {
              if (typeof(item.value) !== 'undefined') {
                return "";
              } else {
                
                return <PlacesCarousel items={items} searchResp={this.state.searchResp} query={this.state.query} section={section} affid={this.state.affid}/>
              }
            }
            // maybe will be reached in the sidebar?
            return <Place item={item} searchResp={this.state.searchResp}  query={this.state.query} section={section} affid={this.state.affid}/>
          } else if(item.answerType === "Computation") {
            return <Computation item={item} searchResp={this.state.searchResp}  query={this.state.query} section={section} affid={this.state.affid}/>
          // taken out because now we have a translation widget
          // } else if(item.answerType === "Translations") {
          //   return <Translation item={item} searchResp={this.state.searchResp}  query={this.state.query} section={section} affid={this.state.affid}/>
          }
        })}
      </div>
    )
  }
  renderWebResults() {
    return this.renderSearchResult("mainline")
  }
  getAlterationQuery(searchResp) {
    let queryContext = searchResp?.queryContext;
    return queryContext?.alteredQuery ? queryContext?.alteredQuery : HtmlToText.htmlToText(queryContext?.alterationDisplayQuery);
  }
  renderAlterationQuery() {
    if (this.state.loadingSearch || this.state.searchResp.queryContext == undefined || !this.state.query) {
      return ("");
    }
    let queryContext = this.state.searchResp.queryContext;
    if (queryContext.alteredQuery && queryContext.originalQuery.charAt(0) !== '+') {
      let alteredQuery = this.getAlterationQuery(this.state.searchResp);
      let alteredDipslayQuery = queryContext.alterationDisplayQuery ? queryContext.alterationDisplayQuery : alteredQuery;
      let alteredLinkString = 
        `<a href=/search?q=${encodeURIComponent(alteredQuery)}&service=${this.state.service}&affid=${encodeURIComponent(this.state.affid)}>${alteredDipslayQuery}</a>`;
      let overrideLinkString =
        `<a href=/search?q=${encodeURIComponent(queryContext.alterationOverrideQuery)}&service=${this.state.service}&affid=${encodeURIComponent(this.state.affid)}>${queryContext.originalQuery}</a>`;
      return (
        alteredQuery && queryContext.alterationOverrideQuery ?
          <div className="alteration-query">
            <MarkupText class="ae-title" id="newSearch.alteredQuery" fields={{ alteredQuery: alteredLinkString }}>
              Showing results for {alteredLinkString}
            </MarkupText>
            <MarkupText class="ae-subtitle-large" id="newSearch.originalQuery" fields={{ overrideQuery: overrideLinkString }}>
              Search instead for {queryContext.originalQuery}
            </MarkupText>
          </div>
        :
        ""
      )
    }
  }
  renderRelatedSearchesWeb() {
    if (this.state.loadingSearch || this.state.searchResp.relatedSearches == undefined || !this.state.query) {
      return ("");
    }
    let relatedSearchList = this.state.searchResp.relatedSearches.value;
    return (
      <div className="related-search">
        <div className="ae-title related-search-title">
          <Text id="newSearch.relatedSearch" fields={{ query: this.state.query }}>Related Searches for {this.state.query}</Text>          
        </div>
        <div className="ae-subtitle-large related-search-text">
          {relatedSearchList.map((obj) => 
            // ToDo: fix apostrophe ' on related search URL encoding
            <a href={`/search?q=${encodeURIComponent(obj.text)}&affid=${encodeURIComponent(this.state.affid)}`}>
              {/* <a onClick={() => this.onSubmit(obj.text)}> */}
              <div className="ae-border-box related-search-item" >
                <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 18 18" width="18px" fill="#DDD">
                  <path d="M0 0h24v24H0V0z" fill="none"/>
                  <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
                </svg>              
                <Markup markup={obj.displayText} type="html" trim={false}/>
              </div>
            </a>
          )}
        </div>
        <br/>
      </div>
    )
  }
  renderRelatedSearchesImagesVideos() {
    let title = <Text id="newSearch.relatedSearches">Related Searches</Text>
    if (this.state.loadingSearch || this.state.searchResp.relatedSearches == undefined || !this.state.query) {
      return ("");
    }
    let relatedSearchList = this.state.searchResp.relatedSearches;
    return (
      <RelatedVideoImages id="related" title={title} searches={relatedSearchList} service={this.state.service} affid={this.state.affid} />
    )
  }
  renderPivotSuggestionsImagesVideos() {
    let title = <Text id="newSearch.pivotSuggestions">Pivot Suggestions</Text>
    if (this.state.loadingSearch || this.state.searchResp.pivotSuggestions == undefined || !this.state.query) {
      return ("");
    }
    let pivotSuggestionsList = [];
    for (let x=0; x < this.state.searchResp.pivotSuggestions.length; x++) {
      pivotSuggestionsList.push(...this.state.searchResp.pivotSuggestions[x].suggestions);
    }
    return (
      <RelatedVideoImages id="pivot" title={title} searches={pivotSuggestionsList} service={this.state.service} affid={this.state.affid} />
    )
  }
  renderSimilatTermsImagesVideos() {
    let title = <Text id="newSearch.similarTerms">Similar Terms</Text>
    
    if (this.state.loadingSearch || this.state.searchResp.similarTerms == undefined || !this.state.query) {
      return ("");
    }
    let similarTermsList = this.state.searchResp.similarTerms;
    return (
      <RelatedVideoImages id="similar" title={title} searches={similarTermsList} service={this.state.service} affid={this.state.affid} />
    )
  }
  renderPagination() {
    if(this.state.service === "shopping" || !this.state.searchResp || this.state.loadingSearch || !this.state.query || ((!this.state.searchResp.webPages && this.state.service === "web") || this.state.searchResp.value?.length === 0)) {
      return ("");
    }
    let pages = [1, 2, 3, 4, 5];
    let pNo = this.state.page;
    if(pNo > 4) {
      pages = [1, "..."];
      for(var ix = (pNo-2); ix <= (pNo+2); ix++) {
        pages.push(ix);
      }
    }
    return (
      <div className="result-pagination ae-title" id="result-pagination">
        {this.state.page > 1 ? (
        <div>
          <span onCLick={() => this.goToPage(this.state.page-1)}> &lt; </span>
        </div>
        ):("")}
        {pages.map(p => {
          if(!isNaN(p)) {
            return <div><span onCLick={() => this.goToPage(p)} className={this.state.page === p? "selected": ""}>{p}</span></div>
          } else {
            return <div><span>{p}</span></div>
          }
        })}
        <div>
            <span onClick={() => this.goToPage(this.state.page+1)}> &gt; </span>
        </div>
      </div>
    )
  }
  renderShoppingSubSection(list, shoplocale, thinkSuggestSource) {
    return (
      <div>
        <div className="shopping-source-info">
        <Text id="newSearch.shoppingDisclaimer">As associates, we receive payment for your qualified purchases</Text>
        </div>
        <div className="shopping-source-products">
          {thinkSuggestSource?.items?.map(item=> {
            return <ThinkSuggestShoppingResult item={item} />
          })}
        </div>
        <div className="shopping-source-products">
          {list.map(prod=> {
            return <OneProduct product={prod} locale={shoplocale} />
          })}
        </div>
      </div>
    )
  }
  renderShopping() {
    let sources = (this.state.searchResp && this.state.searchResp.sources) ? this.state.searchResp.sources : [];
    // check if we have any results and interleave them
    let timetoend = false;
    let list = [];
    let shopcountry = (this.state.searchResp && this.state.searchResp.country) ? this.state.searchResp.country : "US";
    let shoplang = (this.state.searchResp && this.state.searchResp.lang) ? this.state.searchResp.lang : "en";
    let shoplocale = shoplang.split('-')[0] + "-" + shopcountry === "Unknown" ? "US" : shopcountry;

    for(let i = 0; timetoend == false; i++) {
      let thisround = false;
      sources.forEach(source => {
        if(source.source !== "ThinkSuggest") {
          if(source.items && source.items.length > i) {
            let item = source.items[i];
            thisround = true;
            item.source = source.source;
            list.push(item);
          }
        }
      });
      if(!thisround)
        timetoend = true;
    }

    let thinkSuggestSource = sources?.find(source => source.source == 'ThinkSuggest');
    return (
      <div className="result-section-shopping">
            <div className="result-subsection-shopping">
                {this.renderShoppingSubSection(list, shoplocale, thinkSuggestSource)}
            </div>
      </div>
    )
  }
  renderImages() {
    let images = (this.state.searchResp && this.state.searchResp.value) ? this.state.searchResp.value : [];
    return (
      <ImageResults images={images}/>
    )
  }
  renderVideos() {
    let videos = (this.state.searchResp && this.state.searchResp.value) ? this.state.searchResp.value : [];
    return (
      <div>
        <div className="result-section-image">
          {videos.map(video => {
            return <OneVideoSnippets videoBlock={video} snippetType={this.state.snippetType}/>
          })}
        </div>
      </div>
    )
  }
  renderNews() {
    let news = (this.state.searchResp && this.state.searchResp.value) ? this.state.searchResp.value : [];
    return (
      <div>
        <div>
          {news.map(n => {
            return <OneNewsSnippets newsBlock={n} snippetType={this.state.snippetType}/>
          })}
        </div>
      </div>
    )
  }
  renderResults() {
    if(this.state.loadingSearch) {
      return (<div></div>)
    }
    if(this.state.service === "web") {
      return this.renderWebResults();
    }   
    if(this.state.service === "images") {
      return this.renderImages();
    }
    if(this.state.service === "videos") {
      return this.renderVideos();
    }
    if(this.state.service === "news") {
      return this.renderNews();
    }
    if(this.state.service === "shopping") {
      return this.renderShopping();
    }
  }
  renderResultsCountTitle() {
    let resultsCount = "";
    let totalEstimatedMatches = this.state.searchResp.webPages?.totalEstimatedMatches;
    if (this.state.service === "web" && totalEstimatedMatches) {
      let localizedTotal = totalEstimatedMatches.toLocaleString(TranslationUtil.GetLocale(this.state.lang, this.state.currentCountryCode));
      resultsCount = <div><Text id="newSearch.results" fields={{ count: localizedTotal }}>
                      {localizedTotal} Results
                    </Text>
                    &nbsp;&nbsp;&nbsp;</div>
    }          
    if (this.state.service !== "shopping") {
      return (
        <div className="results-count">
          {resultsCount}
          <div className="results-policy">
            <a className="result-count" href='https://go.microsoft.com/fwlink/?LinkId=521839' target='_blank'><Text id="newSearch.microsoftPolicy">Microsoft Privacy</Text></a>
            <AePolicy  service={this.state.service}/>
          </div>
        </div>
      )

    } else return ("");
  }
  renderLogo() {
    return(
      <div className="browse-header-logo">
        <a href="/">
          <img src={this.state.query ? "/images/Browse_logo_small.svg" : "/images/Browse_logo_white.svg"} className="searchImg" />
        </a>
      </div>
    )
  }
  renderAffLogo(afflogo) {
    return(
      <div className={this.state.isRightToLeft ? 'browse-aff-logo rtl' : 'browse-aff-logo'}>
        <div className='affiliate-logo-text'><Text id="newSearch.installedBy">Installed By</Text></div>
        <a href={`/affiliate/link/${affid}`}  target="_blank">
          <img className="affiliate-logo" src={`${AFF_LOGO_BASE}/${afflogo}`} onError={this.handleAffiliateLogoErr.bind(this)} style={{height: "50px"}}/>
        </a>
      </div>
    )
  }
  render() {
    let displaySideStyle = this.state.service !== "shopping" ? {display:"block"}: {display:"none"};
    let clsName = "new-search";
    if(!this.state.query) {
      clsName = "new-search no-query";
    } else {
      this.removeBackgroundImage();
    }
    if(this.state.showAffiliateLogo) {
      clsName += " has-affiliate" 
    }
    let definition = this.state.definition;
    let safeSearchPlaceholder = (definition.newSearch && definition.newSearch.safeSearchPlaceholder) ? definition.newSearch.safeSearchPlaceholder : "";
    //set the title as well here
    if(!this.state.query) {
      document.title = safeSearchPlaceholder;
    }
    let afflogo = this.state.isDarkTheme ? `${affid}-dark.svg` : `${affid}-light.svg`;
    return (
      <IntlProvider definition={definition}>
      <div className={clsName}>
        <div className="search-bar" id="newSearchBarWrapper">
          {this.state.isShowUpperLogo ? "" : ( 
              this.state.showAffiliateLogo ? (
                <div className="logo-with-aff">
                  {this.renderLogo()}
                  {this.renderAffLogo(afflogo)}
                </div>
              ) : (
                this.renderLogo()
              )
          )}
          <div className="browse-input-wrapper">
            <div className={this.state.isShowUpperLogo ? "search-input-logo-weather" : "search-input-logo"}>
              <img style={{display: "none"}} src={`${AFF_LOGO_BASE}/${afflogo}`} onLoad={this.handleAffiliateLogoSuccess.bind(this)}/>
              {this.state.isShowUpperLogo ? ( 
                  this.state.showAffiliateLogo ? (
                    <div className="logo-with-aff">
                      {this.renderLogo()}
                      <div className='affiliate-upper-logoandtext'>
                        {this.renderAffLogo(afflogo)}
                      </div>
                    </div>
                  ) : (
                    this.renderLogo()
                  ) 
                ) : (""
              )}
              <div id="weatherWidget">
                <WidgetLoader name="weather" /> 
              </div>
            </div>
            <SearchInput 
              pos="serp"
              key="browse-search-key"
              onSubmit={this.onSubmit.bind(this)}
              setSafeSearch = {this.setSafeSearch.bind(this)}
              safeSearchLevel = {this.state.safeSearchLevel}
              toggleDarkTheme={this.toggleDarkTheme.bind(this)}
              setTheme={this.setTheme.bind(this)}
              isDarkTheme={this.state.isDarkTheme}
              themeMode={this.state.themeMode}
              showLocationWidget={true} 
              isSafeSearchOn={this.state.isSafeSearchOn}
              currentLocationName={this.state.currentLocationName}
              service={this.state.service}
              safeSearchPlaceholder={safeSearchPlaceholder}
              currentLocation={this.state.currentLocation}
              currentCountryCode={this.state.currentCountryCode}
              hideInputImg={!this.isBrowseLive}
              lang={this.state.lang}
              isRightToLeft={this.state.isRightToLeft}
              affid={this.state.affid}
              />
          </div>
        </div>
        <div className="search-section ae-subtitle-normal">
          <div className={this.state.service === "web" ? "highlighted": ""} onClick={() => this.setService("web")}><Text id="newSearch.all">ALL</Text></div>
          <div className={this.state.service === "images" ? "highlighted": ""} onClick={() => this.setService("images")}><Text id="newSearch.images">Images</Text></div>
          <div className={this.state.service === "videos" ? "highlighted": ""} onClick={() => this.setService("videos")}><Text id="newSearch.videos">Videos</Text></div>
          <div className={this.state.service === "news" ? "highlighted": ""} onClick={() => this.setService("news")}><Text id="newSearch.news">News</Text></div>
        </div>
        {this.renderTopper()}
        <TopWidget searchResp={this.state.searchResp} />
        <div className="search-result">
          <div className="search-result-main">
            <div className="ae-search-widget-block">
              <div className="result-count ae-caption ae-wdg-caption">
                { this.state.service === "shopping" ? 
                  ( <div className="ae-caption affsearchtitle shopping-caption">
                      <Text id="newSearch.searchTitle">Safer Shopping Results</Text>
                      <AePolicy service={this.state.service} />
                    </div> ) : 
                  ( <div className="ae-caption policy-info-wrapper">
                      <Text id="newSearch.bingResult">Results from Microsoft Bing</Text>&nbsp;
                    </div>)
                }
              </div>
              <div className="results-content">
                {this.renderResultsCountTitle()}
                {this.renderAlterationQuery()}
                {this.renderSearchResult("pole")}
                {this.renderResults()}
                {this.state.service === "web" ? this.renderRelatedSearchesWeb() : ""}
                {this.renderPagination()}
              </div>
            </div>
          </div>
          <div className="search-result-side" style={displaySideStyle} id="searchResultSide">
            <div className="side-panel-searchinfo">
              {this.renderSearchResult("sidebar")}
            </div>
            <BottomWidget searchResp={this.state.searchResp}/>
            <div className='related-videos-images-block'>
              {this.state.service === "images" || this.state.service === "videos" ? this.renderRelatedSearchesImagesVideos() : ""}
              {this.state.service === "images" || this.state.service === "videos" ? this.renderPivotSuggestionsImagesVideos() : ""}
              {this.state.service === "images" || this.state.service === "videos" ? this.renderSimilatTermsImagesVideos() : ""}
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <div id="loadingDiv" style={{display: "none"}} className="ui segment">
        <div class="ui active inverted dimmer">
          <div class="ui large text loader" id="loadingDivText"></div>
        </div>        
      </div>
      <AeScrollTop />
      </IntlProvider>
    )
  }
}

let redirect = false;
let affid = GetSetAffiliateId();
try {
  if(window.location.href.indexOf("sl=") > -1) {
    const slparams = new URLSearchParams(window.location.search);
    let saferlink = slparams.get('sl');
    if(saferlink) {
      redirect = true;
      let sluri = GetSaferShoppingUrl(saferlink, affid, "omnibar");
      //console.log("redirecting", sluri)
      window.location.href = sluri;
    }
  }
} catch(err) {
  //console.log("redirecting err", err)
  redirect = false;
}
if(!redirect) {
  render(<BrowseContextProvider adCampaign="serp"><NewSearch affid={affid} /></BrowseContextProvider>, document.getElementById("new-search-page-id"));
}

